import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/uneedle.webp';
import screenshot_target from '../../../images/letterfunnel/jeroenwissink.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jeroen Wissink"
      firstname="Jeroen"
      companyname="Uneedle"
      competition="NanoPass Technologies en Clearside Biomedical"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jeroenwissink.js